'use client'

import sections from '@/components/sections'
import SectionWrapper from '@/containers/SectionWrapper'
import { useSearchParams } from 'next/navigation'
import { ComponentType, ReactNode } from 'react'
import useCustomisation, { PagePath } from 'src/hooks/useCustomisation'

type GeneralComponent = ComponentType<any>

const getSafeComponent = (Component: GeneralComponent): GeneralComponent =>
  Component || (() => null)

// Add type for sections
type SectionType = keyof typeof sections

const DynamicSections = ({ pagePath }: { pagePath: PagePath }): ReactNode => {
  const { pagePopups, pageSections, sortingSectionId } =
    useCustomisation(pagePath)
  const searchParams = useSearchParams()
  const withoutMerchantScript = searchParams?.get('withoutMerchantScript')

  const keyedSections = [...pagePopups, ...pageSections]

  return (
    <>
      {keyedSections.map((section, index) => {
        if (!section.type || section.options?.visibleForPreview === false) {
          return null
        }

        if (withoutMerchantScript && section.type === 'custom-html') return null

        const SectionComponent = getSafeComponent(
          sections[section.type as SectionType]
        )

        return (
          <SectionWrapper
            id={section.id}
            key={section.id}
            sorting={sortingSectionId === section.id}
          >
            <SectionComponent id={section.id} index={index} />
          </SectionWrapper>
        )
      })}
    </>
  )
}

export default DynamicSections
